import { Fragment, useEffect, useRef, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { CommonLoading } from 'react-loadingg';
import { Link, useHistory } from 'react-router-dom';
import ReportsHeader from '../components/Reports/ReportsHeader';
import '../components/Settings/Settings.css';
import ManageUserIcon from '../images/manageuser-icon.svg';
import UserDetailsIcon from '../images/userdetails-icon.svg';
import GrievanceBtn from '../images/apps-grievance.png';
import CommentBtn from '../images/comment.png';
import WorkerPerformanceBtn from '../images/worker_performance_grading.png';

import BulletinBoardBtn from '../images/apps-bulletinboard.svg'

const Reports = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [showUserDetails, setShowUserDetails] = useState(false);
    const [showQREvent, setShowQREvent] = useState(false);
    const [showGrievance, setShowGrievance] = useState(false);
    // const [showWorkerPerformance, setShowWorkerPerformance] = useState(false);

    useEffect(() => {
        if (props.loginList) {
            const loginListFromParent = props.loginList;

            const permit = loginListFromParent.some(
                (item) =>
                    (item.permissionName.includes('Admin Role') && item.permissionType.includes('view')) ||
                    (item.permissionName.includes('Report') && item.permissionType.includes('view')) ||
                    (item.permissionName.includes('QR Event') && item.permissionType.includes('view')) //||
                    // (item.permissionName.includes('Worker Performance Grading') && item.permissionType.includes('view'))
            );

            if (permit) {
                setIsLoading(false);
            } else {
                window.stop();
                alert('You have no permissions to access this page.');
                window.location = '/';
            }

            const userDetailsPermit = loginListFromParent.some(
                (item) =>
                    (item.permissionName.includes('Admin Role') &&
                        item.permissionType.includes('view')) ||
                    (item.permissionName.includes('Report') &&
                        item.permissionType.includes('view'))
            );

            if (userDetailsPermit) {
                setShowUserDetails(true);
            }

            const qrEventPermit = loginListFromParent.some(
                (item) =>
                    (item.permissionName.includes('Admin Role') &&
                        item.permissionType.includes('view')) ||
                    (item.permissionName.includes('QR Event') &&
                        item.permissionType.includes('view'))
            );

            if (qrEventPermit) {
                setShowQREvent(true);
            }

            const grievanceReportPermit = loginListFromParent.some(
                (item) =>
                    (item.permissionName.includes('Admin Role') &&
                        item.permissionType.includes('view')) ||
                    (item.permissionName.includes('Grievance Report') &&
                        item.permissionType.includes('view'))
            );

            if (grievanceReportPermit) {
                setShowGrievance(true);
            }

            //!=== Worker Performance Grading Permit HERE
            // const workerPerformanceGradingPermit = loginListFromParent.some(
            //     (item) => 
            //         (item.permissionName.includes('Admin Role') &&
            //             item.permissionType.includes('view')) ||
            //         (item.permissionName.includes('Worker Performance Grading') &&
            //             item.permissionType.includes('view'))
            // );

            // if (workerPerformanceGradingPermit) {
            //     setShowWorkerPerformance(true);
            // }

        }
    }, [props.loginList]);

    useEffect(() => {
        if (props.grievancePermission) {
            const grievancePermissionFromParent = props.grievancePermission;

            if (grievancePermissionFromParent == 1) {
                setShowGrievance(true);
            }
        }

    }, [props.grievancePermission])

    return (
        <Fragment>
            {isLoading ? (
                <CommonLoading />
            ) : (
                <div className='main-hero-container'>
                    <div
                        className={`${props.isActive ? 'container is-active' : 'container'
                            }`}
                    >
                        <ReportsHeader />
                        <Row>
                            <Col>
                                {showUserDetails && (
                                    <div
                                        className='text-center settings-icon'
                                    >
                                        <Link to='/reports/userdetails' style={{ textDecoration: 'none' }}>
                                            <img
                                                src={UserDetailsIcon}
                                                className='settings-logo'
                                                alt=''
                                            />
                                            <Row>
                                                <span
                                                    className='settings-title'
                                                >
                                                    User Details
                                                </span>
                                            </Row>
                                        </Link>
                                    </div>
                                )}
                            </Col>
                            <Col>
                                {showQREvent && (
                                    <div
                                        className='text-center settings-icon'
                                    >
                                        <Link to='/reports/qrevents' style={{ textDecoration: 'none' }}>
                                            <img
                                                src={ManageUserIcon}
                                                className='settings-logo'
                                                alt=''
                                            />
                                            <Row>
                                                <span
                                                    className='settings-title'
                                                >
                                                    QR Events
                                                </span>
                                            </Row>
                                        </Link>
                                    </div>
                                )}
                            </Col>
                            <Col>
                                {showGrievance && (
                                    <div
                                        className='text-center settings-icon'
                                    >
                                        <Link to='/reports/grievance' style={{ textDecoration: 'none' }}>
                                            <img
                                                src={GrievanceBtn}
                                                className='settings-logo'
                                                alt=''
                                            />
                                            <Row>
                                                <span
                                                    className='settings-title'
                                                >
                                                    Grievance
                                                </span>
                                            </Row>
                                        </Link>
                                    </div>
                                )}
                            </Col>
                            {/* <Col>

                                {showWorkerPerformance && (<div
                                    className='text-center settings-icon'
                                >
                                    <Link to='/reports/workerPerformanceGrade' style={{ textDecoration: 'none' }}>
                                        <img
                                            src={WorkerPerformanceBtn} 
                                            className='settings-logo'
                                            alt=''

                                        />
                                        <Row>
                                            <span
                                                className='settings-title'
                                            >
                                               Worker Performance Grading
                                            </span>
                                        </Row>
                                    </Link>
                                </div>)}

                            </Col> */}
                            {/* <Col>

                                <div
                                    className='text-center settings-icon'
                                >
                                    <Link to='/reports/hodCommentForm' style={{ textDecoration: 'none' }}>
                                        <img
                                            src={CommentBtn}
                                            className='settings-logo'
                                            alt=''

                                        />
                                        <Row>
                                            <span
                                                className='settings-title'
                                            >
                                                HOD Comment
                                            </span>
                                        </Row>
                                    </Link>
                                </div>

                            </Col> */}
                            <Col style={{ visibility: 'hidden' }}></Col>
                            <Col style={{ visibility: 'hidden' }}></Col>
                        </Row>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default Reports;
